import { createAction, props } from '@ngrx/store';

import { Wishlist } from 'src/app/shared/models/wishlist.model';
import { Wish } from 'src/app/shared/models/wish.model';

export const setWishlist = createAction('[Wishlists frontend Component] Set wishlist', props<{wishlist: Wishlist}>());
export const updateWish = createAction('[Wishlists frontend Component] Update wish', props<{ token: string, wish: Wish }>());
export const setPageScrollPosition = createAction('[Wishlists frontend Component] Set page scroll location', props<{x: number, y: number}>());